import { defineStore } from 'pinia'

export const useDataStore = defineStore("data", {
  state: () => ({
    data: [],
    categoryData: null
  }),
  actions: {
    updateData(data) {
      this.data = data
    },
    updateCategoryData(data) {
      this.categoryData = data
    }
  },
  getters: {
    dataIndexMap: (state) => {
      const map = new Map()
      state.data.forEach((item, i) => {
        map.set(item.key, i)
      })
      return map
    }
  }
})